export const PAGE = 1;
export const SIZE = 10;
export const ORDER = 'descend';
export const PAGINATION = {
    page: PAGE,
    size: SIZE,
    order: ORDER,
    total: 0,
    items: [],
    loading: false
};
export const FILTER = {
    page: PAGE,
    size: SIZE,
    order: ORDER,
    field: ''
};